import React, { useContext, useEffect, useState } from 'react';
import { Context_UI } from '../../Contexts/Context_UI';
import UI_Dropdown from '../ERUMAUI/UI_Dropdown';
import UI_Button from '../ERUMAUI/UI_Button';
import UI_LinearGroup from '../ERUMAUI/UI_LinearGroup';
import Element_Map_Editor_Marker from '../InteractiveMap/Element_Map_Editor_Marker';
import { Rooms_Update, Rooms_Get } from '../../api/API_Rooms';
import { useMapEditor } from '../../Contexts/Context_MapEditor';
import { useStatus } from '../../Contexts/Context_Status_Global';

// import { useAuth } from '../Contexts/AuthContext';




export default function Render_MapEditor({ Map_Composition, Selected_Building, Selected_Floor, Floor_Set }) {
    // const { Account, Loading } = useAuth();
    const UI = useContext(Context_UI);
    const { Refresh } = useMapEditor();
    const { Status_Fetching_Set, Status_Saving_Set } = useStatus();


    useEffect(() => {
        const OnRadioSelect = ({ ID_Parent, ID_ActiveButton, ID_ActiveButton_Index }) => {
            Floor_Set(ID_ActiveButton_Index);
        }

        UI.on("Radio_Selected", OnRadioSelect);
        return () => {
            UI.off("Radio_Selected", OnRadioSelect);
        }
    }, []);

    const Selected_Building_Index = Map_Composition.findIndex(
        (Building) => Building.Name === Selected_Building
    );

    const saveRoomPosition = async (roomId, newX, newY) => {
        try {
            Status_Fetching_Set("InProgress");
            const resp = await Rooms_Get(roomId); // you already have this API
            Status_Fetching_Set("Success");
            const room = resp.data;
            const newLocation = {
                ...room.Location,
                Coordinates: { X: String(newX), Y: String(newY) }
            };
            Status_Saving_Set("InProgress");
            await Rooms_Update(roomId, { Location: newLocation });
            Status_Saving_Set("Success");
            Refresh();
        } catch (err) {
            console.error("saveRoomPosition failed", err);
        }
    };

    return (
        <div className='Renderer_Map'>
            <div className='Renderer_Map_Content'>
                {Map_Composition[Selected_Building]?.Floors?.length > 0 ?
                    <>
                        {Map_Composition[Selected_Building].Floors.map((Layer, index) => {
                            const ID = `Controls_Map_Floor_${Layer.Name.Shortened}`;
                            const IsActive = index == Selected_Floor;
                            return (
                                <div className='Renderer_Map_Layer' State={IsActive ? "Active" : "Inactive"}>
                                    <img src={Layer.Plan.FileURL} className='Renderer_Map_Layer_Image' draggable='false' loading='lazy' />
                                    <div className='Renderer_Map_Layer_Markers'>
                                        {Layer.Rooms.length > 0 ? (
                                            Layer.Rooms.map((Room) => (
                                                <Element_Map_Editor_Marker
                                                    key={Room._id}
                                                    id={Room._id}
                                                    x={Number(Room.Location.Coordinates.X)}
                                                    y={Number(Room.Location.Coordinates.Y)}
                                                    Label_Room={Room.Name}
                                                    Label_State="No data"
                                                    onSave={saveRoomPosition}
                                                />
                                            ))
                                        ) : (
                                            "EMPTY"
                                        )}


                                    </div>
                                </div>
                            )
                        })}
                    </>
                    :
                    ""
                }

            </div>
        </div>
    );

}


